import React, { useEffect, useState, useCallback } from "react";
import { SUBMITTED_BATCH_LIST } from "../constant";
import axios from "axios";
import SubmittedBatchTable from "../components/tables/SubmittedBatchTable";
import { currentDateFormat } from "../utils";
import { useDispatch } from "react-redux";
import { setLoading } from "../redux/loaderAction";

const DEFAULT_LIMIT = 10;

const SubmittedBatchList = () => {
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    recordsPerPage: DEFAULT_LIMIT,
  });
  const dispatch = useDispatch();
  const [currentDate, setCurrentDate] = useState(new Date());

  const fetchSubmittedBatchList = useCallback(async (page = 1) => {
    dispatch(setLoading(true));
    try {
      const response = await axios.get(SUBMITTED_BATCH_LIST, {
        params: { page, limit: DEFAULT_LIMIT },
      });
      if (response?.data?.status === "200") {
        setVehicleDetails(response.data.data || []);
        const p = response.data.pagination || {};
        setPagination({
          currentPage: p.currentPage ?? page,
          totalPages: Math.max(1, p.totalPages ?? 1),
          totalRecords: p.totalRecords ?? 0,
          recordsPerPage: p.recordsPerPage ?? DEFAULT_LIMIT,
        });
      } else {
        setVehicleDetails([]);
        setPagination((prev) => ({ ...prev, totalPages: 1, totalRecords: 0 }));
      }
    } catch (error) {
      console.error(error);
      setVehicleDetails([]);
    } finally {
      dispatch(setLoading(false));
    }
  }, []);

  useEffect(() => {
    fetchSubmittedBatchList(currentPage);
  }, [currentPage, fetchSubmittedBatchList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <>
      <section>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600">Submitted Batch List </h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section>
        <div>
          <SubmittedBatchTable
            tableData={vehicleDetails}
            setTabelData={setVehicleDetails}
            questionList={questionList}
            pagination={pagination}
            onPageChange={handlePageChange}
          />
        </div>
      </section>
      {/* {loading && <Loader />} */}
    </>
  );
};
export default SubmittedBatchList;
